import getObject from './get-object.js';
import arrayHasObject from './array-has-object.js';

export default function addToArray(key, object) {
    try {
        const array = getObject(key) || [];

        if (! arrayHasObject(array, object)) {
            array.unshift(object);
            localStorage.setItem(key, JSON.stringify(array));
        }
    } catch (error) {
        console.log(error);
    }
}